/** Wall-clock elapsed: previous segments plus time since the current segment start. */
export function computeProcessingElapsedMs(
  prevElapsedMs: number,
  segmentStartAt: string,
  nowMs: number,
): number {
  const previous = Number.isFinite(prevElapsedMs) ? Math.max(0, prevElapsedMs) : 0;
  const startedAt = Date.parse(segmentStartAt);
  if (!Number.isFinite(startedAt)) {
    return previous;
  }

  return previous + Math.max(0, nowMs - startedAt);
}

/** Formats milliseconds as `HH:MM:SS` with no 24-hour freeze (`25:00:00` allowed). */
export function formatRuntimeHhMmSs(ms: number): string {
  const totalSeconds = Math.floor(Math.max(0, ms) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
